export default __webpack_public_path__ + "static/media/character.8724c191.png";